import { Building2, MapPin, Phone, Mail } from "lucide-react";
import { scrollToSection } from "./Navbar";
import { useLang } from "../context/LangContext";

const QUICK_LINK_IDS = ["services", "projects", "about", "partners", "contact"];

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-[#E8DFC5] bg-[#FBF6E9]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src="/images/logo.png"
                alt="شعار شركة فكرة بغداد"
                className="w-11 h-11 object-contain"
              />
              <span className="leading-tight">
                <span className="block font-heading font-extrabold text-lg text-stone-900">شركة فكرة بغداد</span>
                <span className="block text-[10px] text-stone-500 mt-0.5">
                  للمقاولات والتجارة العامة والاستثمارات الصناعية محدودة المسؤولية
                </span>
                <span className="block font-accent text-[11px] tracking-[0.18em] text-emerald-600 mt-1">
                  FIKRAT BAGHDAD COMPANY
                </span>
                <span className="block font-accent text-[8px] tracking-wide text-stone-500 mt-0.5 max-w-[240px] leading-relaxed">
                  For General Contracting, Trading and Industrial Investments Limited Liability
                </span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-stone-500 max-w-xs">
              {t.footer.about}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base text-stone-800 mb-5">{t.footer.quickTitle}</h4>
            <ul className="flex flex-col gap-3">
              {QUICK_LINK_IDS.map((id) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollToSection(id)}
                    className="text-sm text-stone-500 hover:text-emerald-600 transition-colors duration-200"
                  >
                    {t.nav[id]}
                  </button>
                </li>
              ))}
              <li>
                <a
                  data-testid="footer-link-profile"
                  href="/fikrat-baghdad-profile-2026.pdf"
                  download
                  className="text-sm font-semibold text-emerald-600 hover:text-emerald-700 transition-colors duration-200"
                >
                  {t.footer.profile}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base text-stone-800 mb-5">{t.footer.contactTitle}</h4>
            <ul className="flex flex-col gap-4 text-sm text-stone-500">
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-emerald-500 shrink-0" />
                {t.footer.branch1}
              </li>
              <li className="flex items-center gap-3">
                <Building2 className="w-4 h-4 text-emerald-500 shrink-0" />
                {t.footer.branch2}
              </li>
              <li className="flex items-center gap-3" dir="ltr">
                <Phone className="w-4 h-4 text-emerald-500 shrink-0" />
                +964 770 937 2007
              </li>
              <li className="flex items-center gap-3" dir="ltr">
                <Mail className="w-4 h-4 text-emerald-500 shrink-0" />
                FikratBaghdad@gmail.com
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-[#E8DFC5] py-6">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-wrap items-center justify-between gap-3">
          <p className="text-xs text-stone-500 font-accent tracking-wide">
            {t.footer.rights}
          </p>
          <a
            data-testid="footer-link-admin"
            href="/admin"
            className="text-xs text-stone-400 hover:text-emerald-600 transition-colors duration-200"
          >
            {t.footer.admin}
          </a>
        </div>
      </div>
    </footer>
  );
}
